import React, { Component } from 'react';
import _ from 'lodash';
import numeral from 'numeral';
import dayjs from 'dayjs';
import { withRouter } from 'react-router-dom';

import {
  Button,
  Image,
  BackgroundImage,
  FoodItem,
  Modal,
} from '../../components';
import { withRedux } from '../../hoc';
import { stripHtml } from '../../utils';

import Seat from './Seat';
import Mapsit from './Mapsit';
import userIcon from './svg/user-shape.svg';
import correctIcon from './svg/select-seat.svg';
import Summary from './Summary';

let ticketTypes = [
  { id: 6, color: '#8E99CA', name: 'Vip Diamond', price: 3800 },
  { id: 5, color: '#F5C867', name: 'Vip Gold', price: 2300 },
  { id: 1, color: '#D1D2D3', name: 'Vip Silver', price: 2000 },
  { id: 4, color: '#CD4596', name: 'Mezzanine', price: 1000 },
];

const mapStateToProps = ({ language, t, auth }) => {
  return {
    language,
    t,
    isLogin: _.get(auth, 'isLogin'),
    agentName: _.get(auth, 'data.profile.senate_AgentName'),
    balance: _.toNumber(_.get(auth, 'data.balance')),
  };
};

@withRouter
@withRedux(mapStateToProps)
export default class BookingStep2 extends Component {
  state = {
    selectedData: null,
    selectedFoods: [],
    foodInformation: null,
    prevSelectedData: null,
    isModal: false,
  };

  static defaultProps = {
    selectedDate: '',
    selectedShowtime: '',
    selectedSeat: [],
    seatInformation: [],
    emptySeat: [],
    selectedSeatTotalPrice: null,
  };

  componentDidMount = () => {
    window.scrollTo(0, 0);
    this.init();
  };

  componentDidUpdate(prevProps) {
    if (!_.isEqual(this.props.seatInformation, prevProps.seatInformation)) {
      this.init();
    } else if (!_.isEqual(this.props.selectedSeat, prevProps.selectedSeat)) {
      this.init();
    }
  }

  init = () => {
    this.getSelectedSeatData();
  };

  getSelectedSeatData = () => {
    const { selectedSeat, seatInformation } = this.props;

    const data = _.map(selectedSeat, (seat, index) => {
      const info = _.find(seatInformation, ['seatNo', seat]);
      return {
        seatID: _.get(info, 'seatID'),
        seatNumber: seat,
        price: _.get(info, 'price'),
        seatType: _.get(info, 'seatTypeName'),
        seatTypeID: _.get(info, 'seatTypeID'),
      };
    });

    this.setState({
      selectedData: data,
    });
  };

  handleClickSeat = (values) => {
    this.props.onClickSeat(values);
  };

  handleRemoveFood = (values) => {
    const { selectedFoods } = this.state;

    const targetValue = values.value;
    const targetKey = values.itemID;

    const step1 = _.remove(selectedFoods, (i) => {
      // ******* ยกเว้น *******
      return i.value !== targetValue && i.itemID === targetKey;
    });

    const step2 = _.remove(selectedFoods, (i) => {
      // ******* ยกเว้น *******
      return i.itemID !== targetKey;
    });

    const combine = [...step1, ...step2];
    this.setState({
      selectedFoods: _.sortBy(combine, ['id']),
      // selectedFoods: data,
    });
  };
  handleAddFood = (values) => {
    const { selectedFoods } = this.state;
    const foods = [...selectedFoods, values];

    this.setState({
      selectedFoods: foods,
    });
  };
  handleClickFoodItem = (val) => {
    this.setState({
      isModal: true,
      foodInformation: val,
    });
  };
  handleClickNext = () => {
    const { selectedData, selectedFoods } = this.state;
    const { selectedDate, selectedShowtime } = this.props;
    const bookingSeats = _.map(selectedData, (item) => {
      return {
        ...item,
        SeatID: _.get(item, 'seatID'),
        SeatTypeID: _.get(item, 'seatTypeID'),
      };
    });

    const confirmBookingItems = {
      showDate: selectedDate,
      showTimeID: _.get(selectedShowtime, 'showTimeID'),
      bookingSeat: bookingSeats,
      drinkDinner: selectedFoods,
      amount: _.sumBy(selectedData, 'price') + _.sumBy(selectedFoods, 'price'),
    };

    this.props.onClickNext(confirmBookingItems);
  };
  handleClickPrev = () => {
    const {selectedDate, selectedShowtimeId} = this.props;
    this.setState({
      selectedFoods: [],
    });
    this.props.onClickPrev(selectedDate, selectedShowtimeId);

  };

  render() {
    const {
      selectedData,
      selectedFoods,
      foodInformation,
      isModal,
    } = this.state;
    const {
      selectedDate,
      selectedShowtimeId,
      selectedShowtime,
      selectedSeat,
      emptySeat,
      canBooking,
      t,
      isLogin,
      agentName,
      balance,
      seatInformation,
      selectedSeatTotalPrice,
    } = this.props;
    const textBalance = numeral(balance).format('0,0');
    const groupSeatType = _.groupBy(seatInformation, 'seatTypeID');
    const seatTypes = _.map(groupSeatType, (value, id) => {
      return { id, name: value[0].seatTypeName, price: value[0].price };
    });

    const dinings = _.get(selectedShowtime, 'dinings', []);

    if (!_.isEmpty(seatTypes)) {
      ticketTypes = _.map(ticketTypes, (ticketType) => {
        // const seatType = _.find(
        //   seatTypes,
        //   (seatType) => _.toInteger(seatType.id) === _.toInteger(ticketType.id)
        // );
        const seatType = _.find(seatTypes, (seatType) => {
          return _.toInteger(seatType.id) === _.toInteger(ticketType.id);
        });
        const newTicketType = ticketType;
        if (seatType) {
          newTicketType.price = seatType.price;
        }
        return newTicketType;
      });

      console.log('seatTypes ::', { seatTypes, ticketTypes });
    }

    const disableNextStep =
      _.size(selectedSeat) < 1 ||
      !canBooking ||
      balance < selectedSeatTotalPrice;

    // console.log('render - now', dayjs(selectedDate, 'YYYY/MM/DD').format('ddd')) // Saturday === 'Tue'
    return (
      <div className="booking-step-2">
        <div className="container-title-bar">
          <h2>{t('Select your seats')}</h2>
          <div className="right-block">
            {isLogin && (
              <div className="agent-block">
                <p>
                  <span className="bold">{t('Agent')}:</span> {agentName}
                </p>
                {balance > 0 && (
                  <p className="p-credit">
                    <span className="bold">{t('Credit Remain')}:</span>{' '}
                    {textBalance} {t('THB')}
                  </p>
                )}
              </div>
            )}
            <div className="ticket-type-block">
              {_.map(ticketTypes, (item, index) => {
                return (
                  <div className="ticket-type-item" key={index}>
                    <div className="image-block">
                      <Seat color={_.get(item, 'color')} />
                    </div>
                    <div className="price-block">
                      <p>{t(_.get(item, 'name'))}</p>
                      <p>
                        {numeral(_.get(item, 'price')).format('0,0')}{' '}
                        <span>{t('THB')}</span>
                      </p>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
        <div className="container-detail-seat">
          <div className="seat-item">
            <Seat color="white" />
            <p>{t('Avaliable')}</p>
          </div>
          <div className="seat-item">
            <Image src={userIcon} alt="" />
            <p>{t('Taken')}</p>
          </div>
          <div className="seat-item">
            <div className="image">
              <Seat color="white" />
              <Image className="correct-icon" src={correctIcon} alt="" />
            </div>
            <p>{t('Your Seat')}</p>
          </div>
        </div>
        <div className="container-stage">
          <Mapsit
            onClickSeat={this.handleClickSeat}
            emptySeat={emptySeat}
            selectedSeat={selectedSeat}
          />
        </div>
        <div className="container-food">
          <div className="container-selected-food">
            <h2>{t('foods & drinks')}</h2>
            {dayjs(selectedDate, 'YYYY/MM/DD').format('ddd') === 'Tue' ? (
              <React.Fragment>
                <div className="container-image">
                  <Image src={`${process.env.PUBLIC_URL}/assets/images/message-image.png`} />
                </div>
                <p>{t({ en: 'Thai Marche restaurant is closed every Tuesday.', th: 'ห้องอาหารไทยมาเช่ ปิดบริการทุกวันอังคาร', cn: '泰玛榭餐厅每周二店休。'})}</p>
              </React.Fragment>
            ) : (
              <React.Fragment>
                {_.map(dinings, (item, key) => {
                  return (
                    <FoodItem
                      key={key}
                      data={item}
                      onChangeAddValue={this.handleAddFood}
                      onChangeRemoveValue={this.handleRemoveFood}
                      onClick={this.handleClickFoodItem}
                    />
                  );
                })}
              </React.Fragment>
            )}
          </div>
        </div>
        <Summary
          selectedData={selectedData}
          selectedFoods={selectedFoods}
          selectedShowtime={selectedShowtime}
          selectedDate={selectedDate}
        />
        <div className="container-button">
          <Button
            className="large"
            ghost
            bordercolor="#ffb400"
            onClick={this.handleClickPrev}
            // onClick={() =>
            //   this.props.onClickPrev(selectedDate, selectedShowtimeId)
            // }
          >
            {t('Previous')}
          </Button>
          <Button
            className="large"
            type="primary"
            onClick={this.handleClickNext}
            disabled={disableNextStep}
            style={{ background: disableNextStep ? 'gray' : '' }}
          >
            {t('Next Step')}
          </Button>
        </div>
        <Modal
          className="description-modal"
          centered
          visible={isModal}
          onCancel={() => this.setState({ isModal: false })}
        >
          <div className="image-block">
            <BackgroundImage
              key={_.get(foodInformation, ['image', 'full_file_path'], '')}
              image={_.get(foodInformation, ['image', 'full_file_path'], '')}
            />
          </div>
          <div className="description-content">
            <h2>{t(_.get(foodInformation, 'title', ''))}</h2>
            <p
              className="description-detail"
              dangerouslySetInnerHTML={{
                __html: stripHtml(t(_.get(foodInformation, 'description'))),
              }}
            />
          </div>
        </Modal>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/Booking/BookingStep2.js